import { type ImageProps, Image as TamaguiImage } from "tamagui";
export type { ImageProps };

// Web resolves style props to atomic CSS on tamagui's Image already; only the
// native variant needs to intervene. See Image.native.tsx.
export const Image = TamaguiImage;